import {
  GetReviewQSetSubtaskDetailsByIdDocument,
  GetStepTransitionsByTaskIdDocument,
  useGetStepTransitionsByTaskIdQuery,
  useUpdateTaskStatusMutation,
} from '@exam-management/graphql';
import { isTaskOverdueError, useQSetReviewModal } from '@exam-management/task-management';
import { Button } from '@shared/components';
import debounce from 'lodash/debounce';

interface StartSubtaskButtonProps {
  taskId: string;
}
export default function StartSubtaskButton(props: Readonly<StartSubtaskButtonProps>) {
  const { taskId } = props;

  const { setAction } = useQSetReviewModal();

  const { data } = useGetStepTransitionsByTaskIdQuery({
    variables: {
      getStepTransitionsByTaskIdInput: {
        taskId,
      },
    },
  });

  const [update, { loading: isLoading }] = useUpdateTaskStatusMutation({
    variables: {
      updateTaskStatusInput: {
        taskId,
        workflowStepId: data?.wflGetStepTransitionsByTaskId.steps?.[0]?.id ?? '',
      },
    },
    onError: (error) => {
      if (isTaskOverdueError(error)) {
        setAction('OVERDUE_NOTICE');
      }
    },
    refetchQueries: [
      {
        query: GetStepTransitionsByTaskIdDocument,
        variables: {
          getStepTransitionsByTaskIdInput: {
            taskId,
          },
        },
      },
      {
        query: GetReviewQSetSubtaskDetailsByIdDocument,
        variables: {
          getTaskByIdInput: {
            taskId,
          },
        },
      },
    ],
  });

  const debouncedHandleStartTaskClick = debounce(() => {
    update();
  }, 500);

  const handleStartTaskClick = () => {
    debouncedHandleStartTaskClick();
  };

  return (
    <Button size='large' loading={isLoading} onClick={handleStartTaskClick}>
      Start Task
    </Button>
  );
}
